import React, { useState } from 'react'

import AdminLayout from '../components/AdminLayout'

import './collaboration.css'

type CollabTab = 'updates' | 'tasks' | 'files'

const Collaboration = () => {
  const [tab, setTab] = useState<CollabTab>('updates')

  return (
    <AdminLayout title="Collaboration" activeNav="collaboration" pageTitle="Collaboration - Namami Gange">
      <div className="collab-toolbar">
        <div className="collab-tabs" role="tablist" aria-label="Collaboration views">
          <button
            type="button"
            role="tab"
            aria-selected={tab === 'updates'}
            className={`collab-tab${tab === 'updates' ? ' collab-tab--active' : ''}`}
            onClick={() => setTab('updates')}
          >
            Team updates
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={tab === 'tasks'}
            className={`collab-tab${tab === 'tasks' ? ' collab-tab--active' : ''}`}
            onClick={() => setTab('tasks')}
          >
            Action items
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={tab === 'files'}
            className={`collab-tab${tab === 'files' ? ' collab-tab--active' : ''}`}
            onClick={() => setTab('files')}
          >
            Shared files
          </button>
        </div>
        <button type="button" className="collab-primary">
          New announcement
        </button>
      </div>

      <div className="admin-card-grid">
        <div className="admin-stat-card">
          <h3>Open threads</h3>
          <div className="admin-stat-value">14</div>
          <div className="admin-stat-sub">Cross-site coordination</div>
        </div>
        <div className="admin-stat-card">
          <h3>Unread mentions</h3>
          <div className="admin-stat-value">3</div>
          <div className="admin-stat-sub">Last 48 hours</div>
        </div>
        <div className="admin-stat-card">
          <h3>Shared documents</h3>
          <div className="admin-stat-value">62</div>
          <div className="admin-stat-sub">SOP &amp; permits</div>
        </div>
        <div className="admin-stat-card">
          <h3>Upcoming reviews</h3>
          <div className="admin-stat-value">4</div>
          <div className="admin-stat-sub">This month</div>
        </div>
      </div>

      {tab === 'updates' && (
        <div className="collab-split">
          <div className="admin-panel">
            <h2>Recent announcements</h2>
            <div>
              <div className="collab-thread">
                <div className="collab-thread-avatar" aria-hidden="true" />
                <div className="collab-thread-body">
                  <strong>O&amp;M review — Jagjeetpur</strong>
                  <p>
                    Consolidated KPI pack uploaded. Please acknowledge receipt before Friday EOD so
                    the compliance folder stays green for audit.
                  </p>
                  <div className="collab-thread-meta">Operations · 2 hours ago</div>
                  <div className="collab-chip-row">
                    <span className="collab-chip">Jagjeetpur</span>
                    <span className="collab-chip">Compliance</span>
                  </div>
                </div>
              </div>
              <div className="collab-thread">
                <div className="collab-thread-avatar" aria-hidden="true" />
                <div className="collab-thread-body">
                  <strong>Hazard bulletin — chemical dosing</strong>
                  <p>
                    Revised dosing checklist is live. Shift leads must brief teams during the toolbox
                    talk today.
                  </p>
                  <div className="collab-thread-meta">SHE council · Yesterday</div>
                  <div className="collab-chip-row">
                    <span className="collab-chip">All sites</span>
                    <span className="collab-chip">Safety</span>
                  </div>
                </div>
              </div>
              <div className="collab-thread">
                <div className="collab-thread-avatar" aria-hidden="true" />
                <div className="collab-thread-body">
                  <strong>Vendor coordination · electrical</strong>
                  <p>
                    Backup electrician roster updated for Varanasi cluster. Contacts synced to the
                    directory module.
                  </p>
                  <div className="collab-thread-meta">Contracts · Yesterday</div>
                  <div className="collab-chip-row">
                    <span className="collab-chip">Varanasi</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="admin-panel">
            <h2>Working groups</h2>
            <ul className="collab-side-list">
              <li>
                SHE &amp; QA circle
                <span>28 members</span>
              </li>
              <li>
                Jal Bhushan liaison
                <span>11 members</span>
              </li>
              <li>
                Jal Nigam — data sync
                <span>9 members</span>
              </li>
              <li>
                CCTV escalation
                <span>6 members</span>
              </li>
            </ul>
            <div className="collab-chip-row">
              <span className="collab-chip">Invite guest</span>
              <span className="collab-chip">Mute channel</span>
            </div>
          </div>
        </div>
      )}

      {tab === 'tasks' && (
        <div className="admin-panel">
          <h2>Action items</h2>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Owner</th>
                  <th>Due</th>
                  <th>Priority</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Upload signed O&amp;M addendum · Haridwar</td>
                  <td>Legal</td>
                  <td>12 May</td>
                  <td>High</td>
                  <td>
                    <span className="admin-pill admin-pill--muted">In progress</span>
                  </td>
                </tr>
                <tr>
                  <td>Close corrective action · lab sampling</td>
                  <td>QC lead</td>
                  <td>15 May</td>
                  <td>Medium</td>
                  <td>
                    <span className="admin-pill">On track</span>
                  </td>
                </tr>
                <tr>
                  <td>Confirm roster for outage window</td>
                  <td>Plant supervisor</td>
                  <td>18 May</td>
                  <td>Low</td>
                  <td>
                    <span className="admin-pill admin-pill--neutral">Planned</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab === 'files' && (
        <div className="admin-panel">
          <h2>Shared files</h2>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Document</th>
                  <th>Version</th>
                  <th>Updated</th>
                  <th>Access</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>STP operational SOP bundle</td>
                  <td>v4.2</td>
                  <td>04 May 2026</td>
                  <td>All O&amp;M</td>
                </tr>
                <tr>
                  <td>District compliance tracker (xlsx)</td>
                  <td>May week 1</td>
                  <td>06 May 2026</td>
                  <td>PMU + Jal Nigam</td>
                </tr>
                <tr>
                  <td>Emergency contact roster</td>
                  <td>SPR-26</td>
                  <td>01 May 2026</td>
                  <td>Control room only</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </AdminLayout>
  )
}

export default Collaboration
